import { render, staticRenderFns } from "./express.vue?vue&type=template&id=0db1bb65&scoped=true"
import script from "./express.vue?vue&type=script&lang=js"
export * from "./express.vue?vue&type=script&lang=js"
import style0 from "./express.vue?vue&type=style&index=0&id=0db1bb65&prod&scoped=true&lang=less"
import style1 from "./express.vue?vue&type=style&index=1&id=0db1bb65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db1bb65",
  null
  
)

export default component.exports